import React, { useEffect, useState, useCallback } from 'react';
import { Icon } from '@shakkerai/components';
import { resetFlowData, removeFlow, getReplaceInfo } from '@starflow/app/helpers/flow';
import { eventBus } from '@starflow/app/helpers';
import { FlOW_SOCKET_INFO, FlOW_TYPE, localFileExt, NodeState } from '../../../constants';
import { exportJsonAsFile } from '../../../../../utils/file';
import { scheduleTaskForFlow } from '@starflow/app/helpers/process';
import { notifyWarn } from '@shakkerai/pro-components';
import { Tooltip } from 'antd';
import { useProjectState, setProjectState, useTempState, setTempState, getTempState } from '@starflow/app/store';
import { translate } from '@shakkerai/util-i18n';
import UnifiedReplacement from '../../unified-replacement';

const FlowBtnGroup = ({ flow }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isUnifiedReplacementOpen, setIsUnifiedReplacementOpen] = useState(false);
  const flows = useProjectState('flows');
  const autoRunningFlowId = useProjectState('autoRunningFlowId');
  const replaceList = useTempState('replaceList');

  const runFlow = () => {
    const newFlow = resetFlowData(flow, {
      replaceOldFlow: true,
      clearImageUrl: true,
    });
    eventBus.emit(FlOW_SOCKET_INFO, {
      flowId: newFlow.flowId,
      tp: FlOW_TYPE.UPDATE,
    });
    scheduleTaskForFlow(newFlow.flowId);
  };

  // 流自动运行, 要与画布断联, 更新flowId和nodeId
  const handleClickRunFlow = () => {
    if (autoRunningFlowId) {
      notifyWarn('当前有流正在自动运行中, 请等待流运行完毕后再试试');
      return;
    }

    const replaceInfo = getReplaceInfo(flow.flowId);

    if (replaceInfo.length > 0) {
      setIsUnifiedReplacementOpen(true);
      setTempState('replaceList', replaceInfo);
    } else {
      runFlow();
    }
  };

  const handleCloseUnifiedReplacement = useCallback(() => {
    setIsUnifiedReplacementOpen(false);
  }, []);

  const handleConfirmUnifiedReplacement = useCallback(() => {
    setIsUnifiedReplacementOpen(false);
    runFlow();
  }, [runFlow]);

  const downsLoadFlow = () => {
    const name = `${flow.data.title}.${localFileExt}`;
    exportJsonAsFile(flow, name);
  };

  const editFlow = () => {
    const newFlows = flows.map((f) => {
      if (f.flowId === flow.flowId) {
        f.state = [NodeState.TextEditing];
      }
      return f;
    });
    setProjectState({
      flows: newFlows,
    });
  };

  const toolContent = () => {
    return (
      <div className=" py-2 text-white text-xs rounded-sm">
        <ul className="flex flex-col w-full">
          <li onClick={() => downsLoadFlow()} className="hover:bg-[#424141] cursor-pointer leading-[34px] px-4">
            {translate('flow_g_op2')}
          </li>
          <li onClick={() => removeFlow(flow.flowId)} className="hover:bg-[#424141] cursor-pointer leading-[34px] px-4">
            {translate('flow_g_op3')}
          </li>
          <li onClick={() => editFlow()} className="hover:bg-[#424141] cursor-pointer leading-[34px] px-4">
            {translate('flow_g_op1')}
          </li>
        </ul>
      </div>
    );
  };

  const closeTools = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    window.addEventListener('click', closeTools);
    return () => {
      window.removeEventListener('click', closeTools);
    };
  }, []);
  return (
    <div className="h-[22px] flex bg-[#F4F5F7] justify-center items-center px-1 rounded-sm mt-2">
      <Tooltip
        open={isUnifiedReplacementOpen}
        trigger="click"
        placement="topLeft"
        overlayInnerStyle={{ width: '288px', padding: 0, borderRadius: '2px', backgroundColor: '#2c2c2c' }}
        title={
          <UnifiedReplacement
            replaceList={replaceList}
            onCancel={handleCloseUnifiedReplacement}
            onConfirm={handleConfirmUnifiedReplacement}
          />
        }
        arrow={false}
      >
        <button className="h-[18px] text-center px-1 hover:bg-[#E0E2E7] mr-1">
          <div style={{ transform: 'scale(0.9)' }} onClick={() => handleClickRunFlow()}>
            {autoRunningFlowId === flow.flowId ? '运行中' : '开始运行'}
          </div>
        </button>
      </Tooltip>
      <div className="h-full w-[1px] bg-[#e1e3e9] mr-1"></div>
      <Tooltip
        open={isOpen}
        trigger="click"
        placement="rightTop"
        overlayInnerStyle={{ padding: 0, borderRadius: '2px', backgroundColor: '#2c2c2c' }}
        title={toolContent()}
        arrow={false}
      >
        <Icon
          className="icon-border_more rotate-90 hover:bg-[#E0E2E7] w-[18px] h-[18px] flex justify-center items-center"
          color="#292929"
          fontSize={12}
          onClick={(e) => (e.stopPropagation(), setIsOpen(true))}
        />
      </Tooltip>
    </div>
  );
};
export default FlowBtnGroup;
